module.exports = __webpack_public_path__ + "img/cloud-drizzle-lightning-sun.bab8cdb1.svg";